import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ scrollToSection }) => {
  return (
    <section className="py-24 lg:py-32 bg-[#302f2c] relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1745778110673-c96c14d1c297?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxmb290YmFsbCUyMGNvYWNofGVufDB8fHx8MTc3NjEyOTQ0NXww&ixlib=rb-4.1.0&q=85"
          alt="Football field"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#302f2c] via-[#302f2cdd] to-[#302f2c]"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-2 text-[#d9fb06] mb-6">
            Tu Carrera como Entrenador Comienza con tu Marca Personal
          </h2>
          
          <p className="body-large text-[#dfddd6] mb-10 max-w-2xl mx-auto">
            No esperes más para construir la identidad profesional que te diferenciará 
            en el competitivo mundo del fútbol. Empieza hoy mismo.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={() => scrollToSection('contact')}
              className="btn-primary bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#d9fb06cc] text-lg px-10 py-6"
            >
              Obtener Muestra Gratuita
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-16 pt-16 border-t border-[#3f4816]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <p className="heading-4 text-[#d9fb06] mb-2">Aplicable</p>
                <p className="body-small text-[#888680]">
                  Herramientas prácticas que puedes usar desde el día 1
                </p>
              </div>
              <div>
                <p className="heading-4 text-[#d9fb06] mb-2">Completo</p>
                <p className="body-small text-[#888680]">
                  13 capítulos + cuaderno de desarrollo personal
                </p>
              </div>
              <div>
                <p className="heading-4 text-[#d9fb06] mb-2">Profesional</p>
                <p className="body-small text-[#888680]">
                  Escrito por experto con años de experiencia en gestión deportiva
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
